import React from 'react';
import '../styles/PrivacyPolicy.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  const lastUpdated = 'MAY 30, 2026';

  return (
    <section id="privacy-policy" className="privacy-policy-section">
        <Navbar/>
      <div className="privacy-policy-container">
        
        {/* Hero Section */}
        <div className="privacy-policy-hero">
          <div className="privacy-policy-hero-content">
            <h1 className="privacy-policy-title">Privacy Policy</h1>
            <p className="privacy-policy-subtitle">
              Your privacy matters to us. We are committed to protecting your personal information.
            </p>
            <div className="privacy-policy-last-updated">
              <span>📅 Last Updated: {lastUpdated}</span>
            </div>
          </div>
        </div>

        {/* Quick Navigation */}
        <div className="privacy-policy-nav">
          <h3>Quick Navigation</h3>
          <div className="privacy-policy-nav-links">
            <a href="#introduction">Introduction</a>
            <a href="#information-collect">Information We Collect</a>
            <a href="#how-we-use">How We Use Your Information</a>
            <a href="#data-security">Data Security</a>
            <a href="#your-rights">Your Rights</a>
            <a href="#cookies">Cookies Policy</a>
            <a href="#contact-privacy">Contact Us</a>
          </div>
        </div>

        <div className="privacy-policy-content">
          
          {/* Introduction */}
          <div id="introduction" className="privacy-policy-section-block">
            <h2>1. Introduction</h2>
            <div className="privacy-policy-underline"></div>
            <p>
              Welcome to Preferred Audiology Pvt. Ltd. ("we," "our," "us"). We respect your privacy 
              and are committed to protecting your personal data. This privacy policy explains how 
              we collect, use, disclose, and safeguard your information when you visit our website 
              or use our services.
            </p>
            <p>
              Please read this privacy policy carefully. By accessing or using our website, you 
              acknowledge that you have read, understood, and agree to be bound by the terms of 
              this privacy policy.
            </p>
          </div>

          {/* Information We Collect */}
          <div id="information-collect" className="privacy-policy-section-block">
            <h2>2. Information We Collect</h2>
          <div className="privacy-policy-underline"></div>
            
            <h3>2.1 Personal Information</h3>
            <p>We may collect the following personal information:</p>
            <ul>
              <li><strong>Name</strong> - Your full name</li>
              <li><strong>Contact Information</strong> - Email address, phone number</li>
              <li><strong>Company Details</strong> - Clinic/Distributor name, business address, GST number</li>
              <li><strong>Professional Information</strong> - Position, specialty, business type</li>
            </ul>

            <h3>2.2 Technical Information</h3>
            <ul>
              <li><strong>Device Information</strong> - IP address, browser type, operating system</li>
              <li><strong>Usage Data</strong> - Pages visited, time spent, click interactions</li>
              <li><strong>Location Data</strong> - Approximate geographic location</li>
            </ul>

            <h3>2.3 Business Information</h3>
            <ul>
              <li><strong>Order Details</strong> - Product preferences, order history</li>
              <li><strong>Inquiry Details</strong> - Quote requests, support tickets</li>
              <li><strong>Partnership Information</strong> - Distributor/clinic agreements</li>
            </ul>
          </div>

          {/* How We Collect Information */}
          <div className="privacy-policy-section-block">
            <h2>3. How We Collect Information</h2>
            <div className="privacy-policy-underline"></div>
            <ul>
              <li><strong>Direct Interactions</strong> - When you fill out forms, request quotes, or contact us</li>
              <li><strong>Automated Technologies</strong> - Cookies, server logs, and analytics tools</li>
              <li><strong>Business Communications</strong> - Emails, phone calls, WhatsApp messages</li>
              <li><strong>Third-Party Sources</strong> - Business partners, referral programs</li>
            </ul>
          </div>

          {/* How We Use Your Information */}
          <div id="how-we-use" className="privacy-policy-section-block">
            <h2>4. How We Use Your Information</h2>
            <div className="privacy-policy-underline"></div>
            <p>We use your information for the following purposes:</p>
            <ul>
              <li>✓ To process and respond to your inquiries and quote requests</li>
              <li>✓ To provide products, services, and customer support</li>
              <li>✓ To communicate with you about orders, deliveries, and updates</li>
              <li>✓ To improve our website, products, and services</li>
              <li>✓ To send marketing communications (with your consent)</li>
              <li>✓ To process partnership applications and distributor agreements</li>
              <li>✓ To comply with legal obligations and regulatory requirements</li>
              <li>✓ To detect and prevent fraud or security issues</li>
            </ul>
          </div>

          {/* Legal Basis for Processing */}
          <div className="privacy-policy-section-block">
            <h2>5. Legal Basis for Processing</h2>
            <div className="privacy-policy-underline"></div>
            <p>We process your personal data based on the following legal grounds:</p>
            <ul>
              <li><strong>Contract Performance</strong> - To fulfill our obligations under agreements</li>
              <li><strong>Legitimate Interests</strong> - To improve our services and prevent fraud</li>
              <li><strong>Legal Compliance</strong> - To comply with applicable laws and regulations</li>
              <li><strong>Consent</strong> - For marketing communications and non-essential cookies</li>
            </ul>
          </div>

          {/* Sharing Your Information */}
          <div className="privacy-policy-section-block">
            <h2>6. Sharing Your Information</h2>
            <div className="privacy-policy-underline"></div>
            <p>We may share your information with:</p>
            <ul>
              <li><strong>Service Providers</strong> - Logistics partners, payment processors, IT services</li>
              <li><strong>Business Partners</strong> - With your explicit consent</li>
              <li><strong>Legal Authorities</strong> - When required by law or court order</li>
              <li><strong>Business Transfers</strong> - In case of merger, acquisition, or sale of assets</li>
            </ul>
            <p>We do not sell your personal information to third parties.</p>
          </div>

          {/* Data Security */}
          <div id="data-security" className="privacy-policy-section-block">
            <h2>7. Data Security</h2>
            <div className="privacy-policy-underline"></div>
            <p>We implement appropriate security measures to protect your information:</p>
            <ul>
              <li>✓ SSL/TLS encryption for data transmission</li>
              <li>✓ Secure servers with firewall protection</li>
              <li>✓ Access controls and authentication protocols</li>
              <li>✓ Regular security audits and updates</li>
              <li>✓ Employee training on data protection</li>
            </ul>
            <p>
              While we strive to protect your personal information, no method of transmission 
              over the internet is 100% secure. We cannot guarantee absolute security.
            </p>
          </div>

          {/* Data Retention */}
          <div className="privacy-policy-section-block">
            <h2>8. Data Retention</h2>
            <div className="privacy-policy-underline"></div>
            <p>
              We retain your personal information for as long as necessary to fulfill the purposes 
              outlined in this privacy policy, unless a longer retention period is required by law.
            </p>
            <p>Retention periods:</p>
            <ul>
              <li><strong>Customer Inquiries</strong> - 3 years after last contact</li>
              <li><strong>Order History</strong> - 7 years (for tax and legal purposes)</li>
              <li><strong>Marketing Data</strong> - Until consent is withdrawn</li>
              <li><strong>Partnership Records</strong> - Duration of partnership + 3 years</li>
            </ul>
          </div>

          {/* Your Rights */}
          <div id="your-rights" className="privacy-policy-section-block">
            <h2>9. Your Rights</h2>
            <div className="privacy-policy-underline"></div>
            <p>You have the following rights regarding your personal data:</p>
            <div className="privacy-policy-rights-grid">
              <div className="privacy-policy-right-card">
                <span className="privacy-policy-right-icon">👁️</span>
                <h4>Right to Access</h4>
                <p>Request a copy of your personal data</p>
              </div>
              <div className="privacy-policy-right-card">
                <span className="privacy-policy-right-icon">✏️</span>
                <h4>Right to Rectification</h4>
                <p>Correct inaccurate or incomplete data</p>
              </div>
              <div className="privacy-policy-right-card">
                <span className="privacy-policy-right-icon">🗑️</span>
                <h4>Right to Erasure</h4>
                <p>Request deletion of your data</p>
              </div>
              <div className="privacy-policy-right-card">
                <span className="privacy-policy-right-icon">⛔</span>
                <h4>Right to Object</h4>
                <p>Object to certain data processing</p>
              </div>
              <div className="privacy-policy-right-card">
                <span className="privacy-policy-right-icon">📦</span>
                <h4>Right to Portability</h4>
                <p>Receive your data in a portable format</p>
              </div>
              <div className="privacy-policy-right-card">
                <span className="privacy-policy-right-icon">✋</span>
                <h4>Right to Withdraw Consent</h4>
                <p>Withdraw consent at any time</p>
              </div>
            </div>
            <p>To exercise any of these rights, please contact our grievance officer.</p>
          </div>

          {/* Cookies Policy */}
          <div id="cookies" className="privacy-policy-section-block">
            <h2>10. Cookies Policy</h2>
            <div className="privacy-policy-underline"></div>
            <p>
              We use cookies and similar tracking technologies to enhance your browsing experience. 
              Cookies are small text files stored on your device.
            </p>
            <h3>Types of cookies we use:</h3>
            <ul>
              <li><strong>Essential Cookies</strong> - Required for website functionality</li>
              <li><strong>Analytics Cookies</strong> - Help us understand user behavior</li>
              <li><strong>Preference Cookies</strong> - Remember your settings and preferences</li>
              <li><strong>Marketing Cookies</strong> - For targeted advertising (with consent)</li>
            </ul>
            <p>
              You can manage cookie preferences through your browser settings. Disabling cookies 
              may affect website functionality.
            </p>
          </div>

          {/* Third-Party Links */}
          <div className="privacy-policy-section-block">
            <h2>11. Third-Party Links</h2>
            <div className="privacy-policy-underline"></div>
            <p>
              Our website may contain links to third-party websites. We are not responsible for the 
              privacy practices or content of these external sites. We encourage you to read their 
              privacy policies.
            </p>
          </div>

          {/* Children's Privacy */}
          <div className="privacy-policy-section-block">
            <h2>12. Children's Privacy</h2>
            <div className="privacy-policy-underline"></div>
            <p>
              Our services are not intended for individuals under 18 years of age. We do not knowingly 
              collect personal information from minors. If you believe a minor has provided us with 
              personal information, please contact us.
            </p>
          </div>

          {/* Changes to Policy */}
          <div className="privacy-policy-section-block">
            <h2>13. Changes to This Privacy Policy</h2>
            <div className="privacy-policy-underline"></div>
            <p>
              We may update this privacy policy from time to time. The updated version will be 
              indicated by an updated "Last Updated" date. We encourage you to review this policy 
              periodically.
            </p>
            <p>
              Material changes will be notified via email or a prominent notice on our website.
            </p>
          </div>

          {/* Contact Information */}
          <div id="contact-privacy" className="privacy-policy-section-block">
            <h2>14. Contact Us</h2>
            <div className="privacy-policy-underline"></div>
            <p>If you have any questions about this privacy policy or our data practices, please contact us:</p>
            <div className="privacy-policy-contact-info">
              <div className="privacy-policy-contact-item">
                <span className="privacy-policy-contact-icon">📞</span>
                <div>
                  <strong>Phone</strong>
                  <a href="tel:03323240508">033-23240508</a>
                </div>
              </div>
              <div className="privacy-policy-contact-item">
                <span className="privacy-policy-contact-icon">✉️</span>
                <div>
                  <strong>Email</strong>
                  <a href="mailto:info@paplhear.com">info@paplhear.com</a>
                </div>
              </div>
              <div className="privacy-policy-contact-item">
                <span className="privacy-policy-contact-icon">📍</span>
                <div>
                  <strong>Address</strong>
                  <p>Preferred Audiology Pvt. Ltd.<br />
                  Ecospace Business Towers, Tower 5A, Office no. 508<br />
                  New Town, Kolkata - 700160</p>
                </div>
              </div>
            </div>
          </div>

          {/* Grievance Redressal */}
          <div className="privacy-policy-section-block">
            <h2>15. Grievance Redressal</h2>
            <div className="privacy-policy-underline"></div>
            <p>
              If you have any concerns or complaints regarding data privacy, please contact our 
              Grievance Officer:
            </p>
            <div className="privacy-policy-grievance">
              <p><strong>Name:</strong> Grievance Officer</p>
              <p><strong>Email:</strong> info@paplhear.com</p>
              <p><strong>Response Time:</strong> 30 days</p>
            </div>
          </div>

          {/* Consent */}
          <div className="privacy-policy-section-block">
            <h2>16. Consent</h2>
            <div className="privacy-policy-underline"></div>
            <p>
              By using our website and providing your information, you consent to the collection, 
              use, and disclosure of your information as described in this privacy policy.
            </p>
          </div>

          {/* Download Button */}
          <div className="privacy-policy-download">
            <button className="privacy-policy-download-btn">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M4 16L4 18C4 19.1046 4.89543 20 6 20L18 20C19.1046 20 20 19.1046 20 18L20 16M12 4L12 15M12 15L15 12M12 15L9 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Download Privacy Policy (PDF)
            </button>
          </div>

        </div>
      </div>
      <Footer/>
    </section>
  );
};

export default PrivacyPolicy;